import { Alert } from "antd";
import { RowSpacer } from "../../../../style/containers";
import { FormRow } from "../../../../style/form";
import { InputTextStyled } from "../../../../style/Input";
import { ButtonConfirm } from "../../../Layout/Buttons";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import useSearchSubjects from "../../../../hooks/useSearchSubjects";
import {
  useAddPolicySubjectContext,
  useAddPolicySubjectDispatch,
} from "./AddPolicySubjectContext";
import SubjectsList, { SubjectsListItem } from "../SubjectsList";
import { useSubjects } from "../../../../hooks/useSubjects";
import { Subject } from "../../../../redux/apiSpecifications/apiSubjects";
import { FlexWrapper } from "../../../../style/FlexWrapper";

interface ISearchOrAddSubjectStepProps {
  onNextStep: () => void;
}

const SearchOrAddSubjectStep = ({
  onNextStep,
}: ISearchOrAddSubjectStepProps) => {
  const { t } = useTranslation();

  const dispatch = useAddPolicySubjectDispatch();

  const { claim } = useAddPolicySubjectContext();

  const {
    subjectsList,
    pagedSearchSubjectsParams,
    searchSubjectsPromise,
    changePaginationPromise,
  } = useSearchSubjects();

  const { getSubjectPromise } = useSubjects();

  const [subjectName, setSubjectName] = useState<string | undefined>(undefined);
  const [subjectTaxId, setSubjectTaxId] = useState<string | undefined>(
    undefined
  );

  const handleOnAddNewSubject = () => {
    dispatch!({
      type: "INIT_NEW_SUBJECT",
      payload: {
        tenantId: claim.policy?.tenantId!,
      },
    });

    onNextStep();
  };

  const handleOnSearchSubjects = () => {
    dispatch!({ type: "SET_API_INTERACTING_STATUS", payload: "refreshing" });

    return searchSubjectsPromise({
      pageNum: 1,
      pageLen: 5,
      scenario: "search",
      searchSubjectsParams: {
        tenantId: claim.policy?.tenantId!,
        name: subjectName,
        taxId: subjectTaxId,
      },
    })
      .then(() => {
        dispatch!({ type: "SET_API_INTERACTING_STATUS", payload: "idle" });
      })
      .catch((error) => {
        console.error(error);
        // displayFetchBaseQueryErrorNotification(error);

        dispatch!({ type: "SET_API_INTERACTING_STATUS", payload: "idle" });
      });
  };

  const handlePaginationChange = async (
    pageIndex: number,
    pageSize: number
  ) => {
    dispatch!({ type: "SET_API_INTERACTING_STATUS", payload: "refreshing" });

    return changePaginationPromise(pageIndex, pageSize).then(() => {
      dispatch!({ type: "SET_API_INTERACTING_STATUS", payload: "idle" });
    });
  };

  const handleOnSelectSubject = (subject: SubjectsListItem) => {
    dispatch!({ type: "SET_API_INTERACTING_STATUS", payload: "refreshing" });

    return getSubjectPromise(subject.id!).then((_subject) => {
      dispatch!({
        type: "SET_SELECTED_SUBJECT",
        payload: _subject!,
      });

      onNextStep();

      dispatch!({ type: "SET_API_INTERACTING_STATUS", payload: "idle" });
    });
  };

  return (
    <FlexWrapper flexDirection="column" gap="2em">
      <Alert message={t("MESSAGES.search-or-create-new-subject")} type="info" />

      <FlexWrapper>
        <ButtonConfirm onClick={handleOnAddNewSubject}>
          {t("BUTTONS.create-new-subject")!}
        </ButtonConfirm>
      </FlexWrapper>

      <FormRow>
        <InputTextStyled
          label={t("LABELS.subject-name")}
          placeholder={t("PLACEHOLDERS.subject-name")}
          onChange={(value) => setSubjectName(value)}
          value={subjectName}
        />

        <RowSpacer />

        <InputTextStyled
          label={t("LABELS.subject-tax-id")}
          placeholder={t("PLACEHOLDERS.subject-tax-id")}
          onChange={(value) => setSubjectTaxId(value)}
          value={subjectTaxId}
        />

        <RowSpacer />

        <div style={{ marginTop: "auto" }}>
          <ButtonConfirm onClick={handleOnSearchSubjects}>
            {t("BUTTONS.search-subjects")!}
          </ButtonConfirm>
        </div>
      </FormRow>

      <div>
        {subjectsList && subjectsList.items && (
          <SubjectsList
            subjects={subjectsList}
            onSelectItem={handleOnSelectSubject}
            onPaginationChange={handlePaginationChange}
          />
        )}
      </div>
    </FlexWrapper>
  );
};

export default SearchOrAddSubjectStep;
